<section id="money-pak-section" class="section-card-content" data-cy="deposit-moneypak-screen">
  <form [formGroup]="moneyPakForm">
    <p class="details tw-text-[15px] tw-text-[#020101]" data-cy="deposit-moneypak-details">
      Green Dot® MoneyPak® - The fast and convenient way
      to deposit with cash into your AmWager.com account.
      Instant funding. <br>
      <span class="should-yellow tw-font-bold">To Deposit</span>
      with Green Dot MoneyPak: Pick up a Green
      Dot MoneyPak from the Prepaid Product Section of a
      retailer near you, including Walgreens, Rite Aid, Kroger,
      Ralphs and Weis Markets.
    </p>

    <p class="reminder tw-text-[16px] tw-text-[#6FAAFA] tw-mt-[13px] tw-mb-[28px]" data-cy="deposit-moneypak-reminder">
      <span>*</span>Your IP Address and location will be recorded for fraud prevention purposes.
    </p>

    <div class="deposit-details tw-mb-[30px]">

      <div class="row">
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#0F2950]" data-cy="deposit-moneypak-funds">
            Funds Available
          </span>
        </div>
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#0F2950]" data-cy="deposit-moneypak-funds-avail">
            Immediately
          </span>
        </div>
      </div>

      <div class="row">
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#0F2950]" data-cy="deposit-moneypak-24hr-limit">
            24-hr Limit
          </span>
        </div>
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#0F2950]" data-cy="deposit-moneypak-4dep">
            $1,500 or Four Deposits
          </span>
        </div>
      </div>

      <div class="row">
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#0F2950]" data-cy="deposit-moneypak-7day-limit">
            7-day Limit
          </span>
        </div>
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#0F2950]" data-cy="deposit-moneypak-7dep">
            $3,500 or Seven Deposits
          </span>
        </div>
      </div>

      <div class="row">
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#0F2950]" data-cy="deposit-moneypak-30day-limit">
            30-day Limit
          </span>
        </div>
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#0F2950]" data-cy="deposit-moneypak-20dep">
            $5,000 or Twenty Deposits
          </span>
        </div>
      </div>

    </div>

    <div class="amount-row tw-relative">
      <!-- Message section -->
      <!-- tw-top-[-18px] -->
      <span class="tw-absolute tw-bottom-[-19px] tw-right-[0px] tw-h-[18px] tw-block tw-pt-[2px]">

        <!-- Required -->
        <span
          class="tw-block tw-text-right tw-text-xs tw-text-[#D83A19]"
          *ngIf="formVal['moneyPakNumber'] && formVal['moneyPakNumber']?.errors
            && (formVal['moneyPakNumber'].touched || formVal['moneyPakNumber'].dirty)"
          data-cy="deposit-moneypak-error"
        >
          {{
            formVal['moneyPakNumber']?.errors?.['min']
              ? 'Cannot deposit less than $25.'
              : formVal['moneyPakNumber']?.errors?.['max']
                ? 'Cannot deposit greater than $10,000.'
                : 'Please enter valid money pak number.'
          }}
        </span>
      </span>

      <span class="amount-deposit-usd tw-block tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-moneypak-input-label">
        Moneypak Number:
      </span>
      <input
        formControlName="moneyPakNumber"
        id="depositAmount"
        (keyup)="depositAmount()"
        type="number"
        class="amount tw-h-[38px] tw-text-[22px] tw-text-[#645858]"
        placeholder=""
        pattern="^\d+(\.\d{1,2})?$"
        amwager3DecimalInput
        data-cy="deposit-moneypak-input"
      />
    </div>

    <button
      (click)="deposit()"
      [ngClass]="{'active': (moneyPakNumber && !isDepositing && formVal['moneyPakNumber'].valid)}"
      [disabled]="!moneyPakNumber || isDepositing || formVal['moneyPakNumber'].invalid"
      class="deposit-now tw-w-full tw-h-[41px] tw-text-[16px] tw-mt-[30px] tw-mb-[10px]"
      data-cy="deposit-moneypak-button"
    >
      Deposit Now
    </button>

    <p class="notice tw-text-center tw-text-[14px] tw-text-[#6FAAFA]" data-cy="deposit-moneypak-note">
      <span class="should-yellow tw-text-[#0F2950]">Note:</span> Some retailers take up to one hour to process the
      sale of a Moneypak. If your Moneypak number is not
      working after 1 hour Please call MoneyPak <br>
      <span class="support tw-text-[#0F2950]">Support at 866-795-7597.</span>
    </p>
  </form>
</section>
